import React from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import Avatar from "components/common/Avatar";
import { useAuth } from "hooks/useAuth";
import paths from "routes/paths";

const ProfileDropdown = () => {
  const { account, logout } = useAuth();

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar name={account ? account.name : null} size={undefined} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          {import.meta.env.VITE_REACT_APP_ENVIRONMENT !== "Production" && (
            <Dropdown.Item as={Link} to={paths.feedback}>
              Feedback
            </Dropdown.Item>
          )}
          <Dropdown.Divider />
          {import.meta.env.VITE_REACT_APP_ENVIRONMENT !== "Production" && (
            <Dropdown.Item as={Link} to="#!">
              Settings
            </Dropdown.Item>
          )}
          <Dropdown.Item as={Link} onClick={logout}>
            Logout
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
